import { defaultHttpClient } from '../../httpClient';
import type {
  PostVerificationIssueRequest,
  PostVerificationIssueResponse,
} from './types';

/**
 * SMS 인증번호 발급. iOS/Android 네이티브와 동일한 /verification/issue/ 엔드포인트
 * (trailing slash 포함). webview는 slash 없이 호출하나 백엔드는 양쪽 수용.
 */
export const postVerificationIssue = (params: PostVerificationIssueRequest) => {
  return defaultHttpClient
    .request<PostVerificationIssueResponse>({
      method: 'POST',
      url: '/api/v2/verification/issue/',
      data: params,
    })
    .then(result => result.data);
};
